"use client";

import { useTranslations } from "next-intl";
import { NumberField } from "@/components/form";

export const NumberOfCarsField = () => {
	const t = useTranslations("pages.CustomerInformationPage");

	return (
		<NumberField
			name="numberOfCars"
			label={t("numberOfCars.label")}
			labelPlacement="outside"
			min={0}
			step={1}
			format={{ maximumFractionDigits: 0 }}
		/>
	);
};
